import {
  ContentLayout,
  CustomTable,
  DeleteModal,
  HeaderBreadcrumbs,
} from "../../../shared";
import * as React from "react";
import { Button, Chip, Stack, Tooltip, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { sortItems } from "../../../utils";
import { useStampCardsList } from "../hooks";
import InputControl from "../../../shared/components/InputControl";
import CloseIcon from "@mui/icons-material/Close";
import { StampCardsSettings } from "../components";

const statusStyles = {
  published: { backgroundColor: "#E1FBF2", color: "#0F875B" },
  draft: { backgroundColor: "#1560D414", color: "#1560D4" },
  paused: { backgroundColor: "#FFF6E0", color: "#B26A00" },
  ended: { backgroundColor: "#FFE7E3", color: "#C42B1C" },
};

export const StampCardsList = () => {
  const navigate = useNavigate();
  const { state, globalData, onChangeFilter, onSeachClear, resetFilters } =
    useStampCardsList();

  const ActionButtons = ({ id }) => {
    return (
      <div className="action-buttons" onClick={(e) => e.preventDefault()}>
        <Link to={`details/${id}`}>
          <img alt="details" src="/icons/arrow_forward.svg" />
        </Link>
      </div>
    );
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Stamp Card Name",
        accessor: "name",
        sortType: (prev, curr, columnId) => sortItems(prev, curr, columnId),
      },
      {
        Header: "Stamps",
        accessor: "total_stamps",
        align: "center",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => {
          // find label from global data
          const statusObj = globalData?.stamp_cards?.stamp_card_status?.find(
            (item) => item.value === value,
          );

          const label = statusObj?.label || "";
          const styleKey = label.toLowerCase();

          const chipStyle = statusStyles[styleKey] || {
            backgroundColor: "#eee",
            color: "#666",
          };

          return (
            <Chip
              label={label}
              size="small"
              sx={{
                backgroundColor: chipStyle.backgroundColor,
                color: chipStyle.color,
                fontWeight: 500,
              }}
            />
          );
        },
      },

      {
        Header: "Action",
        id: "action",
        align: "right",
        disableSortBy: true,
        disableGlobalFilter: true,
        accessor: (row, index) => {
          return <ActionButtons id={row.id} />;
        },
      },
    ],
    [navigate, globalData],
  );

  const tabs = React.useMemo(
    () => [
      {
        label: "Stamp Cards",
        value: "1",
        panel: (
          <CustomTable
            columns={columns}
            isLoading={state.isLoading}
            data={state.dataList}
            defaultSearch={false}
            tableId="stampCards"
            onRowLink={(row) => `details/${row.id}`}
            filterContent={
              <Stack
                sx={{
                  flexDirection: "row",
                  gap: "10px",
                  width: "100%",
                }}
              >
                <InputControl
                  type="table-search"
                  name="searchText"
                  placeholder="Search"
                  size="small"
                  width="100%"
                  value={state.filters.searchText}
                  onChange={onChangeFilter}
                  onClear={onSeachClear}
                />
                <Button
                  type="button"
                  size="medium"
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => navigate("create")}
                  sx={{ width: "215px" }}
                  disabled
                >
                  New Stamp Card
                </Button>
              </Stack>
            }
            filterSection={
              <Stack
                direction="row"
                gap="16px"
                alignItems="center"
                justifyContent="flex-end"
                width="100%"
              >
                <InputControl
                  type="select"
                  name="status"
                  label="Status"
                  value={state.filters.status}
                  optionValue={globalData?.stamp_cards?.stamp_card_status ?? []}
                  width="150px"
                  onChange={onChangeFilter}
                />
                <Button
                  type="button"
                  size="medium"
                  variant="text"
                  color="gray"
                  sx={{
                    minWidth: "40px",
                    p: "8px",
                  }}
                  onClick={() => resetFilters()}
                >
                  <CloseIcon />
                </Button>
              </Stack>
            }
          />
        ),
      },
      {
        label: "Settings",
        value: "2",
        panel: <StampCardsSettings />,
      },
    ],
    [
      columns,
      state,
      globalData,
      onChangeFilter,
      onSeachClear,
      resetFilters,
      navigate,
    ],
  );

  return (
    <>
      <ContentLayout
        title="Stamp Cards"
        breadcrumbs={
          <HeaderBreadcrumbs
            links={[{ name: "Dashboard", href: "/" }, { name: "Stamp Cards" }]}
          />
        }
        tabProps={{
          label: "stampCardsList",
          list: tabs,
        }}
      >
      </ContentLayout>
    </>
  );
};
